import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McdRbtLineList } from '@/sc/entities/mcdRbt/McdRbtLineList';

export const McdRbtDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'mcdRbtLine', label: 'Rebate Lines', content: <McdRbtLineList mcdRbtId={entityObj.id} /> },
    {
      id: 'validation',
      label: 'Validations',
      content: <ValList parentEntity="MCD_RBT" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
